import React, { useEffect, useMemo, useState } from "react";
import { InputField } from "../../../../Components/formElements/InputField";
import { Col, Row } from "react-bootstrap";
import DataTable from "react-data-table-component";
import toast from "react-hot-toast";

//Redux
import { useSelector } from "react-redux"; //useDispatch

//Service
import ItemService from "../../../../services/customer_appCommonService";
import ItemServiceV2 from "../../../../services/customer_v2_appCommonService";
import {
  getTodayDate,
  getTodaysData,
  validateContactNumber,
  validateRegistration,
  validateRequired,
  validPostalCode,
} from "../../../../common/Validations";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import TableDropdownMenu from "../../../../Components/TableDropdownMenu/TableDropdownMenu";
import Layout from "../../../../Layout/Layout";
import MaterialSelectionModal from "../Scheduling/MaterialSelectionModal";
import CustomerConstants from "../../../../common/CustomerConstants";
import { useNavigate } from "react-router-dom";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";

const message = {
  VALID_CUSTOMER_NAME: "Special characters or numbers are not allowed.",
  VALID_MAIL_ID: "Please enter a valid email address.",
  VALID_ALTERNATE_MAIL_ID: "Please enter a valid alternate email address.",
  VALID_CONTACT_NUMBER: "Please enter a valid contact number.",
  VALID_ALTERNATE_CONTACT_NUMBER:
    "Please enter a valid alternate contact number.",
  VALID_PURPOSE_JUSTIFICATION:
    "Please ensure the justification is under 500 characters.",
  VALID_POSTAL_CODE: "Enter a 6-character postal code.",
  VALID_CONTACT_FIRST_NAME: "Special characters and numbers are not allowed",
  VALID_CONTACT_LAST_NAME: "Special characters and numbers are not allowed",
  EXIStS_MAIL_ID: "Email already exists",
  EXIStS_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_MAIL_ID: "Alternate Contact Number already exists",
  FILL_REQUIRED_FIELD: "Please fill the required field",
  ALTERNATE_MAIL_ID: "Email ID is same",
  ALTERNATE_CONTACT_NUMBER: "Contact number is same",
  GET_MAP_DISTANCE: "Please Click the Get Distance & Time button",
};
const ManualInvoiceCreate = () => {
  localStorage.setItem("menu", "Sales");
  localStorage.setItem("submenu", "Invoice");

  const navigate = useNavigate();

  let userData = useSelector((state) => state?.user?.data);

  const exForDropdownData = [
    { id: 1, name: "Ex-Work" },
    { id: 1, name: "FOR" },
  ];

  let productDetailsCol = [
    {
      name: "Sl.No",
      selector: (row) => row.local_id || "--",
      cell: (row) => <>{row.local_id}.</>,
      sortable: true,
      width: "80px",
    },
    {
      name: "Material",
      selector: (row) => row.materialLongText,
      sortable: true,
      width: "120px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold text-primary">
            {row.materialLongText}{" "}
          </p>
          <p className="m-0 p-0 ">{row.materialCode} </p>
        </div>
      ),
    },
    {
      name: "A/C",
      selector: (row) => row.accOnOff,
      sortable: true,
      width: "120px",
      cell: (row) => (
        <div class="form-check form-switch">
          <input
            className="form-check-input custom-switch"
            type="checkbox"
            role="switch"
            id={`switch-${row.local_id}`}
            checked={row.accOnOff === true}
            onChange={(event) => handleCheckboxChange(row.local_id, event)}
          />
        </div>
      ),
    },
    {
      name: "UOM",
      selector: (row) => row.uOM || "--",
      sortable: true,
      width: "100px",
    },

    {
      name: "Qty",
      selector: (row) => row.orderQuantityLoad || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="orderQuantityLoad"
          placeholder=""
          value={row.orderQuantityLoad || ""}
          // disabled={true}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
        />
      ),
      sortable: true,
      width: "100px",
    },
    {
      name: "Unit Price",
      selector: (row) => row.unitPrice || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="unitPrice"
          placeholder=""
          value={row.unitPrice || ""}
          // disabled={true}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
        />
      ),
      sortable: true,
      width: "130px",
    },
    {
      name: "EX/FOR",
      cell: (row) => (
        <>
          <TableDropdownMenu
            index={row?.local_id}
            label={"EX/FOR"}
            data={exForDropdownData}
            id={"exWork"}
            name={"exWork"}
            code={"exWorkCode"}
            description={"exWorkDescription"}
            onChange={handleDropdownChange}
            // required={true}
          />
        </>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Dispatch Date",
      selector: (row) => row.dispatchDate || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="dispatchDate"
          type="date"
          placeholder=""
          value={row.dispatchDate || getTodayDate("")}
          disabled={false}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      width: "200px",
    },

    {
      name: "Basic Amt",
      selector: (row) => row.basicAmount || "--",
      cell: (row) => <span>{row.basicAmount} </span>,

      sortable: true,
      width: "120px",
    },
    {
      name: "CGST",
      selector: (row) => row?.cgstValue || "--",
      // cell: (row) => <span>{row?.cgstValue} </span>,
      cell: (row) => <span>{row.isIGST ? 0 : row?.cgstValue}</span>,

      sortable: true,
      width: "100px",
    },
    {
      name: "SGST",
      selector: (row) => row?.sgstValue || "--",
      // cell: (row) => <span>{row?.sgstValue} </span>,
      cell: (row) => <span>{row.isIGST ? 0 : row?.sgstValue}</span>,

      sortable: true,
      width: "100px",
    },
    {
      name: "GST",
      selector: (row) => row?.gstValue || "--",
      cell: (row) => <span>{row?.gstValue} </span>,

      sortable: true,
      width: "100px",
    },
    // {
    //   name: "IGST",
    //   cell: (row, index) => (
    //     <div className="d-flex align-items-center">
    //       <input
    //         type="checkbox"
    //         checked={row.isIGST}
    //         // onChange={() => handleInputChange(index)}
    //         style={{ marginRight: "8px" }}
    //       />
    //       {row.isIGST && (
    //         <InputField
    //           type="number"
    //           className="inputBox"
    //           value={row.igstPercent}
    //           // onChange={(e) => handleInputChange(e.target.value, index)}
    //           placeholder="%"
    //           style={{ width: "60px" }}
    //         />
    //       )}
    //     </div>
    //   ),
    //   width: "140px",
    // },

    {
      name: "IGST",
      cell: (row) => (
        <div className="d-flex align-items-center">
          <input
            type="checkbox"
            checked={row.isIGST}
            onChange={(e) =>
              handleInputChange(row.local_id, {
                target: { name: "isIGST", value: e.target.checked },
              })
            }
            style={{ marginRight: "8px" }}
          />
          {row.isIGST && (
            <InputField
              type="number"
              className="inputBox"
              name="igstPercent"
              value={row.igstPercent || ""}
              onChange={(e) => handleInputChange(row.local_id, e, "Number")}
              placeholder="%"
              style={{ width: "60px" }}
              disabled={true}
            />
          )}
        </div>
      ),
      width: "140px",
    },

    {
      name: "Net Value",
      selector: (row) => row?.netValue || "--",
      cell: (row) => <span>{row?.netValue} </span>,

      sortable: true,
      width: "120px",
    },

    {
      name: "CGST%",
      selector: (row) => row?.cgst || "--",
      //       cell: (row) => (
      //   <span>{row.cgst ? row.cgst : 0}</span>
      // ),

      cell: (row) => <span>{row.isIGST ? 0 : row?.cgst}</span>,

      sortable: true,
      width: "100px",
    },
    {
      name: "SGST%",
      selector: (row) => row?.sgst || "--",
      //      cell: (row) => (
      //   <span>{row.sgst ? row.sgst : 0}</span>
      // ),
      cell: (row) => <span>{row.isIGST ? 0 : row?.sgst}</span>,

      sortable: true,
      width: "100px",
    },

    {
      name: "Delete",
      selector: (row) => row.local_id || "--",
      sortable: true,
      cell: (row) => (
        <button className="" onClick={() => removeProductDetails(row.local_id)}>
          <i className="bi bi-trash text-danger fs-4" />
        </button>
      ),
      width: "120px",
    },
  ];
  let ewayBillNumberData = [
    {
      id: "1",
      name: "Yes",
    },
    {
      id: "2",
      name: "No",
    },
  ];

  //required
  /*  let dropdownOption = [
    {
      id: "1",
      name: "30 Days",
    },
    {
      id: "2",
      name: "60 Days",
    },
    {
      id: "3",
      name: "90 Days",
    },
  ]; */
  const defaultCustomerDetails = {
    customerName: "",
    address: "",
    address2: "",
    address3: "",
    state: "",
    cityPostalCode: "",
    certifications: "",
  };

  const [modalShow, setModalShow] = useState(false);
  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);

  const [godownData, setGodownData] = useState([]);

  const [invoiceData, setInvoiceData] = useState();

  const [getDropdownData, setDropdownData] = useState("");
  const [getProductDetailsData, setProductDetailsData] = useState([]); //productDetailsData
  // console.log(">>getProductDetailsData", getProductDetailsData);
  const [getProductDetailsCol] = useState(productDetailsCol);

  const [disable, setDisabled] = useState(false);
  const [getCustomer, setCustomer] = useState([]);
  const [getCompanyCode, setCompanyCode] = useState([]);

  const [getCustomerDetails, setCustomerDetails] = useState(null);
  const [getCompanyDetails, setCompanyDetails] = useState(null);

  const [truckData, setTruckData] = useState([]);

  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };
  const [getFailureModal] = useState(failureModalData);

  const [getErrorFields, setErrorFields] = useState([]);
  const [getShowFailureModal, setShowFailureModal] = useState(false);

  const [formInputs, setFormInputs] = useState({
    orderStatus: "Pending",
    orderPlacedBy: "",
    customerDetails: "",
    emailAddress: "",
    deliveryAddress: "",
    customerDetailsIfOther: "",
    createdDate: new Date(),
    createdBy: userData?.userId,
    dispatchDate: getTodayDate(""),
    loadingTruckNo: "",
    loadingOtherTruckNo: "",
    godownAddress: "",
  });

  /* pop failure modal */
  const [validation, setValidation] = useState({});
  // console.log("validation", validation);

  const [totals, setTotals] = useState({
    totalBags: 0,
    totalAmount: 0,
    totalCgst: 0,
    totalSgst: 0,
    totalNetValue: 0,
  });

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };

  useEffect(() => {
    loadMasterData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData]);

  useEffect(() => {
    if (getDropdownData?.textDesc === "customerNameDesc") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.id,
        [getDropdownData?.textDesc]: getDropdownData?.description,
        sapDocumentNumber: getDropdownData?.sapDocumentNumber,
      }));
      getCustomerDetail(getDropdownData?.id);
      setFormInputs((formInputs) => ({ ...formInputs, projectName: "" }));
    } else if (getDropdownData?.textCode === "projectNameCode") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.id,
        [getDropdownData?.textDesc]: getDropdownData?.description,
        sapProjectCode: getDropdownData?.sapProjectCode,
      }));
    } else if (getDropdownData?.textDesc === "companyCodeDesc") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.id,
        [getDropdownData?.textDesc]: getDropdownData?.description,
        sapProjectCode: getDropdownData?.sapProjectCode,
      }));
      getCompanyMaster(getDropdownData?.id);
      customerDataDropdown(getDropdownData?.id);
    } else if (getDropdownData?.textDesc === "godownAddressDesc") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.id,
        [getDropdownData?.textDesc]: getDropdownData?.description,
        sapProjectCode: getDropdownData?.sapProjectCode,
      }));
    } else if (getDropdownData?.textDesc === "loadingTruckNoDesc") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.id,
        [getDropdownData?.textDesc]: getDropdownData?.description,
        sapProjectCode: getDropdownData?.sapProjectCode,
      }));
    }

    setValidation((prev) => ({
      ...prev,
      [getDropdownData?.textField]: "",
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  //others toggle
  const [othersCustomer, setOthersCustomer] = useState(false); // default false
  const onCheckBoxChange = (event) => {
    setOthersCustomer(event.target.checked);
    setCustomerDetails(defaultCustomerDetails);
  };

  const removeProductDetails = (local_id) => {
    setProductDetailsData((prevPrograms) => {
      const filteredData = prevPrograms.filter(
        (program) => program.local_id !== local_id
      );
      // Reset and update `local_id` sequentially
      const updatedData = filteredData.map((item, index) => ({
        ...item,
        local_id: index + 1, // Reset local_id after removal
        orderQuantityLoad: "",
      }));
      return updatedData;
    });
  };

  const handleInputChange = (local_id, event, type) => {
    const { name, value } = event.target;

    if (type === "Number" && isNaN(value)) {
      toast.error("Please enter a valid number");
      return;
    }

    setProductDetailsData((prevRows) =>
      prevRows.map((row) => {
        if (row.local_id !== local_id) return row;

        let updatedRow = { ...row, [name]: value };

        // ✅ Handle IGST toggle
        if (name === "isIGST") {
          updatedRow.isIGST = value === true || value === "true"; // convert to boolean

          if (updatedRow.isIGST) {
            // store previous cgst/sgst values
            updatedRow.prev_cgst = row.cgst;
            updatedRow.prev_sgst = row.sgst;
            updatedRow.prev_cgstValue = row.cgstValue;
            updatedRow.prev_sgstValue = row.sgstValue;
          } else {
            // restore old cgst/sgst values
            updatedRow.cgst = row.prev_cgst || 0;
            updatedRow.sgst = row.prev_sgst || 0;
            updatedRow.cgstValue = row.prev_cgstValue || 0;
            updatedRow.sgstValue = row.prev_sgstValue || 0;
          }
        }

        // ✅ Basic calculations
        const orderQuantityLoad =
          parseFloat(updatedRow?.orderQuantityLoad) || 0;
        const unitPrice = parseFloat(updatedRow?.unitPrice) || 0;
        const reversePercentage =
          parseFloat(updatedRow.reversePercentage) || 100;

        updatedRow.basicPrice =
          Math.round((unitPrice / reversePercentage) * 100) / 100;

        // updatedRow.basicAmount =
        //   Math.round(updatedRow.basicPrice * orderQuantityLoad * 100) / 100;

        updatedRow.basicAmount =
          Math.round(
            (updatedRow.unitPrice / updatedRow.reversePercentage) *
              orderQuantityLoad *
              100
          ) / 100;

        if (updatedRow.isIGST) {
          // ✅ Use IGST = cgst% + sgst%
          const cgst = parseFloat(row.prev_cgst ?? updatedRow.cgst) || 0;
          const sgst = parseFloat(row.prev_sgst ?? updatedRow.sgst) || 0;
          const igstPercent = cgst + sgst;

          updatedRow.igstPercent = igstPercent;
          updatedRow.igstValue =
            Math.round(((igstPercent * updatedRow.basicAmount) / 100) * 100) /
            100;

          updatedRow.gstValue = updatedRow.igstValue;
          updatedRow.netValue = (
            updatedRow.basicAmount + updatedRow.igstValue
          ).toFixed(2);
        } else {
          // ✅ Normal cgst+sgst mode
          const cgst = parseFloat(updatedRow.cgst) || 0;
          const sgst = parseFloat(updatedRow.sgst) || 0;

          updatedRow.cgstValue =
            Math.round(((cgst * updatedRow.basicAmount) / 100) * 100) / 100;
          updatedRow.sgstValue =
            Math.round(((sgst * updatedRow.basicAmount) / 100) * 100) / 100;

          updatedRow.gstValue = updatedRow.cgstValue + updatedRow.sgstValue;
          updatedRow.netValue = (
            updatedRow.basicAmount + updatedRow.gstValue
          ).toFixed(2);

          updatedRow.igstValue = 0;
        }

        // ✅ Round off
        updatedRow.rounded = Math.round(parseFloat(updatedRow.netValue));
        updatedRow.difference = (
          updatedRow.rounded - parseFloat(updatedRow.netValue)
        ).toFixed(2);

        // ✅ Debit/Credit defaults
        updatedRow.creditAmount = 0;
        updatedRow.debitAmount = parseFloat(updatedRow.rounded);

        return updatedRow;
      })
    );
  };

  const calculatedTotals = useMemo(() => {
    if (!getProductDetailsData || getProductDetailsData.length === 0) {
      return {
        totalBags: 0,
        totalAmount: "0.00",
        totalCgst: "0.00",
        totalSgst: "0.00",
        totalNetValue: "0.00",
      };
    }

    const totals = getProductDetailsData.reduce(
      (acc, item) => {
        acc.totalBags += parseFloat(item.orderQuantityLoad) || 0;
        acc.totalAmount += parseFloat(item.basicAmount) || 0;
        acc.totalCgst += parseFloat(item.cgstValue) || 0;
        acc.totalSgst += parseFloat(item.sgstValue) || 0;
        acc.totalNetValue += parseFloat(item.netValue) || 0;
        return acc;
      },
      {
        totalBags: 0,
        totalAmount: 0,
        totalCgst: 0,
        totalSgst: 0,
        totalNetValue: 0,
      }
    );

    return {
      totalBags: totals.totalBags,
      totalAmount: totals.totalAmount.toFixed(2),
      totalCgst: totals.totalCgst.toFixed(2),
      totalSgst: totals.totalSgst.toFixed(2),
      totalNetValue: totals.totalNetValue.toFixed(2),
    };
  }, [getProductDetailsData]);

  const rounded = Math.round(totals.totalNetValue); // Nearest whole number
  const difference = (rounded - totals.totalNetValue).toFixed(2);

  useEffect(() => {
    setTotals(calculatedTotals);

    setFormInputs((prev) => ({
      ...prev,
    }));
  }, [calculatedTotals]);

  const othersOnInputChange = ({ target: { name, value } }) => {
    const errors = {};

    setCustomerDetails((customerDetails) => ({
      ...customerDetails,
      [name]: value,
    }));
    setValidation((prev) => ({
      ...prev,
      [name]: errors[name] || "",
    }));
  };

  const hideFailureModal = () => {
    setShowFailureModal(false);
  };

  /* handle save */
  const handleSave = async () => {
    const requiredFields = [];
    const anyFieldNotEmpty = Object.values(validation).some(
      (value) => value !== null && value !== ""
    );
    if (anyFieldNotEmpty) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      return;
    }

    // if (!validateRequired(formInputs.shippingPostalCode)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setValidation((prev) => ({
    //     ...prev,
    //     shippingPostalCode: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }

    // if (!validPostalCode(formInputs.shippingPostalCode)) {
    //   requiredFields.push(`${message.VALID_POSTAL_CODE}`);
    //   setValidation((prev) => ({
    //     ...prev,
    //     shippingPostalCode: message.VALID_POSTAL_CODE,
    //   }));
    //   return;
    // }

    if (getProductDetailsData.length === 0) {
      toast.error("Please add atleast one record!", {
        duration: 4000,
        position: "top-right",
      });
      return;
    }

    const finalobj = getProductDetailsData.map((item) => ({
      ...item,
      ...formInputs,
      loadingTruckNo: formInputs.loadingTruckNo,
      loadingTruckNoDescription: formInputs.loadingTruckNoDesc,
      loadingOtherTruckNo: formInputs.loadingOtherTruckNo,
      transporterDriverName: formInputs.transporterDriverName,
      godownAddress: formInputs.godownAddress,
    }));

    // const filteredData = finalobj
    //   .map(({ _id, ...rest }) => rest) // Remove _id field
    //   .filter((item) => item.orderQuantityLoad?.trim() !== "");

    // if (filteredData.length === 0) {
    //   toast.error("Bag value should not be empty !!", {
    //     duration: 4000,
    //     position: "top-right",
    //   });
    //   return;
    // }
    const filteredData = finalobj.map(({ _id, ...rest }) => rest);
    // Check if any item has empty orderQuantityLoad
    const hasEmptyOrderQuantityLoad = filteredData.some(
      (item) =>
        !item.orderQuantityLoad ||
        item.orderQuantityLoad.toString().trim() === ""
    );

    // Check if any item has empty unitPrice (strict check)
    const hasEmptyUnitPrice = filteredData.some(
      (item) =>
        item.unitPrice === undefined ||
        item.unitPrice === null ||
        item.unitPrice.toString().trim() === "" ||
        Number(item.unitPrice) === 0
    );

    if (hasEmptyOrderQuantityLoad) {
      toast.error("Bag value should not be empty !!", {
        duration: 4000,
        position: "top-right",
      });
      return;
    }

    if (hasEmptyUnitPrice) {
      toast.error("Unit price should not be empty or zero !!", {
        duration: 4000,
        position: "top-right",
      });
      return;
    }

    if (!validateRequired(invoiceData.ewayBill)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        ewayBill: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }

    const obj = {
      data: {
        companyCode: filteredData[0].companyCode,
        companyCode2: filteredData[0].companyCode,
        companyCodeDesc: filteredData[0].companyCodeDesc,
        // customerCode: filteredData[0].customerCode || "",
        customerCode: getCustomerDetails?.customerCode || "",
        customerName:
          filteredData[0].customerName || getCustomerDetails?.customerName,
        deliveryName: filteredData[0].projectName,

        address: getCustomerDetails?.address,
        address2: getCustomerDetails?.address2,
        address3: getCustomerDetails?.address3,
        state: getCustomerDetails?.state,
        cityPostalCode: getCustomerDetails?.cityPostalCode,
        certifications: getCustomerDetails?.certifications,

        othersCustomerStatus: othersCustomer,
        otherCustomerContactName:
          getCustomerDetails?.otherCustomerContactName || "",
        otherCustomerContactNumber:
          getCustomerDetails?.otherCustomerContactNumber || "",

        companyAddress: [
          getCompanyDetails?.address,
          getCompanyDetails?.address2,
          getCompanyDetails?.address3,
          getCompanyDetails?.city,
          getCompanyDetails?.state,
        ]
          .filter(Boolean) // Removes falsy values (null, undefined, empty strings)
          .join(" "),
        companyPostalCode: getCompanyDetails?.cityPostalCode,
        companyCertifications: getCompanyDetails?.certifications,
        companyBankDetails: getCompanyDetails?.bandkDetails || "",
        companyContact: [
          { contant1: "9448380669" },
          { contant2: "7411677666" },
        ],
        companyMail: "svah2003@gmail.com",

        items: filteredData,
        manualInvoice: true,
        totals: calculatedTotals,

        ewayBill: invoiceData.ewayBill,
        transaction: "Sales",
        transactionType: "INV",
                  generatedDate: getTodaysData(),
                  postingDate: getTodaysData(),
        //required
        // dispatchDocumnetNr: invoiceData.dispatchDocumnetNr,
        // billOfLading: invoiceData.billOfLading,
        // termsOfDelivery: invoiceData.termsOfDelivery || "",
        // generatedDate: invoiceData.generatedDate || "",
        // distance: invoiceData.distance || "",
        // supplyType: invoiceData.supplyType || "",
        // transactionType: invoiceData.transactionType || "",
        // mode: invoiceData.mode || "",
        // termsOfPayment: invoiceData.termsOfPayment || "",
      },
    };
  //  console.log(">>obj ",obj)
    setDisabled(true);
    await ItemServiceV2.addInvoice(obj).then((item) => {
      if (item?.status === 200) {
        // handleSearchFuncApi();
        toast.success(item?.message || "added successfully", {
          duration: 2000,
          position: "top-right",
        });
        navigate(CustomerConstants.CUSTOMER_V2_INVOICE_LIST); // Navigate to detail page
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
      setDisabled(false);
    });
  };

  const loadMasterData = async () => {
    let obj1 = {
      codeType: "companyCode",
    };
    await ItemService.getMasterData(obj1).then((item) => {
      if (item?.status === 200) {
        setCompanyCode(item?.data);
      } else {
        setCompanyCode([]);
        console.log(">> Error: Loading Company Code");
      }
    });

    // Get warehouse data
    let obj3 = {
      codeType: "warehouse",
    };
    await ItemService.getMasterData(obj3).then((item) => {
      if (item?.status === 200) {
        setGodownData(item.data || []);
      } else {
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });

    //truck number
    let obj2 = {
      codeType: "truckCode",
    };
    await ItemService.getMasterData(obj2).then((item) => {
      if (item?.status === 200) {
        setTruckData(item.data || []);
      } else {
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });
  };

  const customerDataDropdown = async (code) => {
    let obj = {
      companyCode: code,
    };

    await ItemService.getCustomersByCompany(obj).then((item) => {
      if (item?.status === 200) {
        setCustomer(item?.data);
      } else {
        setCustomer([]);
        console.log(">> Error: Loading getCustomers");
      }
    });
  };

  // Onselect of Country state will load
  const getCustomerDetail = async (userId) => {
    let obj1 = {
      documentNumber: userId,
    };
    await ItemService.getCustomerDetail(obj1).then((item) => {
      // console.log(">> item!", item);
      if (item?.status === 200) {
        setCustomerDetails(item?.data[0] || null);
      } else {
        setCustomerDetails([]);
        console.log(">> Error: Loading getProjectName");
      }
    });
  };

  // Onselect of company, cuatomer will load
  const getCompanyMaster = async (code) => {
    let obj1 = {
      code: code,
    };
    await ItemServiceV2.getCompanyMaster(obj1).then((item) => {
      if (item?.status === 200) {
        setCompanyDetails(item?.data[0] || null);
      } else {
        setCompanyDetails([]);
        console.log(">> Error: Loading getProjectName");
      }
    });
  };

  const handleGetSelectedMaterial = (selectedData) => {
    setProductDetailsData((prevData) => {
      const updatedData = [
        ...prevData,
        ...selectedData.map((item, index) => ({
          ...item,
          local_id: index + 1, // Continue local_id from previous data
          dispatchDate: getTodayDate(""),
          orderStatus: "Pending",
          orderQuantityLoad: "",
          customerAddress: [
            getCustomerDetails?.address,
            getCustomerDetails?.address2,
            getCustomerDetails?.address3,
            getCustomerDetails?.state,
          ]
            .filter(Boolean) // Removes falsy values (null, undefined, empty strings)
            .join(" "),
          customerPostalCode: getCustomerDetails?.cityPostalCode,
          certifications: getCustomerDetails?.certifications,

          companyAddress: [
            getCompanyDetails?.address,
            getCompanyDetails?.address2,
            getCompanyDetails?.address3,
            getCompanyDetails?.city,
            getCompanyDetails?.state,
          ]
            .filter(Boolean) // Removes falsy values (null, undefined, empty strings)
            .join(" "),
          companyPostalCode: getCompanyDetails?.cityPostalCode,
          companyCertifications: getCompanyDetails?.certifications,
        })),
      ];

      // Remove duplicates based on _id
      const uniqueData = Array.from(
        new Map(updatedData.map((item) => [item._id, item])).values()
      );

      // Sort based on `local_id`
      const sortedData = uniqueData
        .map((item, index) => ({
          ...item,
          local_id: index + 1, // Reset local_id sequentially
        }))
        .sort((a, b) => a.local_id - b.local_id);

      return sortedData;
    });
  };

  //toggle Account button
  const handleCheckboxChange = (local_id, event) => {
    const checkedValue = event.target.checked ? true : false;

    setProductDetailsData((prevRows) =>
      prevRows.map((row) =>
        row.local_id === local_id ? { ...row, accOnOff: checkedValue } : row
      )
    );
  };
  const handleDropdownChange = (data) => {
    setProductDetailsData((prevRows) =>
      prevRows.map((row) =>
        row.local_id === data.index
          ? {
              ...row,
              [data.name]: data.value,
              [data.code]: data.codeValue,
              [data.desc]: data.descValue,
            }
          : row
      )
    );
  };

  /* Modal Function */
  const addProductDetails = () => {
    const requiredFields = [];
    const anyFieldNotEmpty = Object.values(validation).some(
      (value) => value !== null && value !== ""
    );
    if (anyFieldNotEmpty) {
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      return;
    }
    if (!validateRequired(formInputs.companyCode)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setValidation((prev) => ({
        ...prev,
        companyCode: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!othersCustomer) {
      if (!validateRequired(formInputs.customerName)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setValidation((prev) => ({
          ...prev,
          customerName: message.FILL_REQUIRED_FIELD,
        }));
        return;
      }
    } else {
      if (!validateRequired(getCustomerDetails?.customerName)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setValidation((prev) => ({
          ...prev,
          customerName: message.FILL_REQUIRED_FIELD,
        }));
        return;
      }
      if (!validateRequired(getCustomerDetails?.address)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setValidation((prev) => ({
          ...prev,
          address: message.FILL_REQUIRED_FIELD,
        }));
        return;
      }
      if (!validateRequired(getCustomerDetails?.cityPostalCode)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setValidation((prev) => ({
          ...prev,
          cityPostalCode: message.FILL_REQUIRED_FIELD,
        }));
        return;
      }
      if (!validPostalCode(getCustomerDetails?.cityPostalCode)) {
        requiredFields.push(`${message.VALID_POSTAL_CODE}`);
        setValidation((prev) => ({
          ...prev,
          cityPostalCode: message.VALID_POSTAL_CODE,
        }));
        return;
      }
      if (!validateRequired(getCustomerDetails?.otherCustomerContactNumber)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setValidation((prev) => ({
          ...prev,
          otherCustomerContactNumber: message.FILL_REQUIRED_FIELD,
        }));
        return;
      }

      if (
        !validateContactNumber(getCustomerDetails?.otherCustomerContactNumber)
      ) {
        requiredFields.push(`${message.VALID_CONTACT_NUMBER}`);
        setValidation((prev) => ({
          ...prev,
          otherCustomerContactNumber: message.VALID_CONTACT_NUMBER,
        }));
        return;
      }
    }
    if (!validateRequired(formInputs.godownAddress)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setValidation((prev) => ({
        ...prev,
        godownAddress: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.loadingTruckNo)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setValidation((prev) => ({
        ...prev,
        loadingTruckNo: message.FILL_REQUIRED_FIELD,
      }));
      return;
    } else if (
      formInputs?.loadingTruckNo === "000 - OTHERS" &&
      !validateRequired(formInputs.loadingOtherTruckNo)
    ) {
      setValidation((prev) => ({
        ...prev,
        loadingOtherTruckNo: message.FILL_REQUIRED_FIELD,
      }));
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      return;
    }
    if (!validateRequired(formInputs.transporterDriverName)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setValidation((prev) => ({
        ...prev,
        transporterDriverName: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }

    setModalShow(true);
  };

  useEffect(() => {
    if (formInputs.loadingTruckNo !== "000 - OTHERS") {
      setValidation((prev) => ({
        ...prev,
        loadingOtherTruckNo: "",
      }));
    }
  }, [formInputs.loadingTruckNo]);

  const hideModal = () => {
    setModalShow(false);
  };

  useEffect(() => {
    if (getCustomerDetails) {
      setFormInputs((prev) => ({
        ...prev,
        shippingAddress: [
          getCustomerDetails?.address,
          getCustomerDetails?.address2,
          getCustomerDetails?.address3,
          getCustomerDetails?.state,
        ]
          .filter(Boolean)
          .join("\n"),

        shippingPostalCode: getCustomerDetails?.cityPostalCode || "",
      }));
    }
  }, [getCustomerDetails]);

  const onInputChange = (e) => {
    const errors = {};
    const { name, value } = e.target;
    setFormInputs((prevInputs) => ({
      ...prevInputs,
      [name]: name === "loadingOtherTruckNo" ? value.toUpperCase() : value,
    }));
    validateRegistration(name === "loadingOtherTruckNo" ? value : "")
      ? (errors.loadingOtherTruckNo = "")
      : (errors.loadingOtherTruckNo = message.VALID_CONTACT_FIRST_NAME);
    setValidation((prev) => ({
      ...prev,
      [name]: value === "" ? "" : errors[name] || "",
    }));
  };

  useEffect(() => {
    setInvoiceData((invoiceData) => ({
      ...invoiceData,
      [getDropdownData?.textField]: getDropdownData?.name,
      [getDropdownData?.textCode]: getDropdownData?.code,
      [getDropdownData?.textDesc]: getDropdownData?.description,
    }));
  }, [getDropdownData]);

  //required
  // const onInputChangeInvoice = ({ target: { name, value } }) => {
  //   setInvoiceData((invoiceData) => ({ ...invoiceData, [name]: value }));
  // };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} lg={12} className="rightSide quoation">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">Manual Invoice Createion</h2>
            <p className="subText">Manual Invoice Creation </p>
            <hr />

            <Row className="mb-4">
              {/* <Col xs={12} md={4} lg={4} className="text-left">
                <button
                  className="btnBack"
                  // onClick={() => navigateToWorkflow()}
                >
                Create Manula Invoice
                </button>
              </Col> */}
            </Row>
            {/* Invoice header */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">GH</span>
                    </Col>
                    <Col xs={12} md={9} lg={9}>
                      <span className="headerTitle">Invoice Header</span>
                      <span className="subHeaderTitle">Invoice Header</span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <Row>
                    <Col xs={12} md={12} lg={12}>
                      <div className="accordion-body">
                        <Col xs={12} md={12} lg={12} className="p-2">
                          <p className="fs-5 mb-0">
                            {/* {invoiceData?.companyCodeDesc} */}
                          </p>
                          <p className="fs-5 mb-0">
                            {/* {invoiceData?.companyAddress} */}
                          </p>
                        </Col>
                        <Row>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <ComboboxField
                              label="Company Name"
                              placeholder=""
                              data={getCompanyCode}
                              id="companyCode"
                              iconClassName="dropdownIcon"
                              name="companyCode"
                              code="companyCode"
                              description="companyCodeDesc"
                              setValue={formInputs.companyCode || ""}
                              getvalue={setDropdownData}
                              required={true}
                              error={validation.companyCode}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <TextAreaField
                              className="inputBox"
                              label="Company Address"
                              name="companyAddress"
                              value={[
                                getCompanyDetails?.address,
                                getCompanyDetails?.address2,
                                getCompanyDetails?.address3,
                                getCompanyDetails?.city,
                                getCompanyDetails?.state,
                              ]
                                .filter(Boolean)
                                .join(" ")}
                              disabled={true}
                            />
                          </Col>
                        </Row>
                        <Col xs={12} md={12} lg={12} className="p-2">
                          <p className="fw-bold mb-0">Billing:</p>

                          <Row>
                            {!othersCustomer && (
                              <>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commLeftRightPadding"
                                >
                                  <ComboboxField
                                    label="Customer Name"
                                    placeholder=""
                                    data={getCustomer}
                                    id="customerName"
                                    iconClassName="dropdownIcon"
                                    name="customerName"
                                    code="customerCode"
                                    description="customerNameDesc"
                                    setValue={formInputs.customerName || ""}
                                    getvalue={setDropdownData}
                                    required={true}
                                    error={validation.customerName}
                                  />
                                </Col>

                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commLeftRightPadding"
                                >
                                  <TextAreaField
                                    className="inputBox"
                                    label="Customer Address"
                                    name="projectAddress"
                                    value={[
                                      getCustomerDetails?.address,
                                      getCustomerDetails?.address2,
                                      getCustomerDetails?.address3,
                                      getCustomerDetails?.state,
                                      getCustomerDetails?.cityPostalCode,
                                    ]
                                      .filter(Boolean) // Removes falsy values (null, undefined, empty strings)
                                      .join(" ")}
                                    // onChange={onInputChange}
                                    disabled={true}
                                  />
                                </Col>
                              </>
                            )}

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commLeftRightPadding d-flex align-items-center"
                            >
                              <input
                                className="form-check-input"
                                type="checkbox"
                                // role="othersCustomer"
                                // data-role="othersCustomer"
                                id="othersCustomer"
                                checked={othersCustomer}
                                // checked={othersCustomer === "true"}
                                onChange={onCheckBoxChange}
                              />
                              <p className="m-0 ps-1 fw-medium text-dark ">
                                Others{" "}
                              </p>
                            </Col>
                          </Row>
                          {othersCustomer && (
                            <Row>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commLeftRightPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Customer Name"
                                  id="customerName"
                                  name="customerName"
                                  // type="text"
                                  value={getCustomerDetails?.customerName}
                                  onChange={othersOnInputChange}
                                  // disabled={false}
                                  required={true}
                                  error={validation.customerName}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commLeftRightPadding"
                              >
                                <TextAreaField
                                  className="inputBox"
                                  label="Address"
                                  id="address"
                                  name="address"
                                  value={getCustomerDetails?.address}
                                  onChange={othersOnInputChange}
                                  // disabled={false}
                                  error={validation.address}
                                />
                              </Col>

                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commLeftRightPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Pin Code"
                                  id="cityPostalCode"
                                  name="cityPostalCode"
                                  // type="text"
                                  value={getCustomerDetails?.cityPostalCode}
                                  onChange={othersOnInputChange}
                                  // disabled={false}
                                  error={validation.cityPostalCode}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commLeftRightPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Contact Name"
                                  id="otherCustomerContactName"
                                  name="otherCustomerContactName"
                                  // type="text"
                                  value={
                                    getCustomerDetails?.otherCustomerContactName
                                  }
                                  onChange={othersOnInputChange}
                                  // disabled={false}
                                  // error={validation.shippingPostalCode}
                                />
                              </Col>

                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commLeftRightPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Contact Number"
                                  id="otherCustomerContactNumber"
                                  name="otherCustomerContactNumber"
                                  // type="text"
                                  value={
                                    getCustomerDetails?.otherCustomerContactNumber
                                  }
                                  onChange={othersOnInputChange}
                                  // disabled={false}
                                  error={validation.otherCustomerContactNumber}
                                />
                              </Col>
                            </Row>
                          )}

                          <p className="fs-5 mb-0">
                            {/* {invoiceData?.customerName} */}
                          </p>
                          <p className="fs-5 mb-0">
                            {/* {invoiceData?.items
                                                ? invoiceData?.items[0]?.customerAddress
                                                : ""} */}
                          </p>
                        </Col>
                        <Col xs={12} md={12} lg={12} className="p-2">
                          <p className="fw-bold mb-0">Shipping:</p>
                          <Row>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commLeftRightPadding"
                            >
                              <TextAreaField
                                className="inputBox"
                                label="Shipping Address"
                                name="shippingAddress"
                                value={formInputs.shippingAddress || ""}
                                onChange={onInputChange}
                                // disabled={true}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commLeftRightPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Shipping Postal Code"
                                name="shippingPostalCode"
                                value={formInputs.shippingPostalCode || ""}
                                onChange={onInputChange}
                                // disabled={true}
                              />
                            </Col>
                          </Row>
                          {/* {invoiceData?.items
                                                ? invoiceData?.items[0]?.shippingAddress + " "
                                                : ""} */}
                          {/* {invoiceData?.items
                                                ? invoiceData?.items[0]?.shippingPostalCode
                                                : ""} */}
                        </Col>
                        <Col xs={12} md={12} lg={12} className="p-2">
                          <p className="fw-bold mb-0">Godown:</p>
                          <Row>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commLeftRightPadding"
                            >
                              <ComboboxField
                                label="Godown"
                                placeholder=""
                                data={godownData}
                                id="godownAddress"
                                iconClassName="dropdownIcon"
                                name="godownAddress"
                                code="customerCode"
                                description="godownAddressDesc"
                                setValue={formInputs?.godownAddress || ""}
                                getvalue={setDropdownData}
                                required={true}
                                error={validation.godownAddress}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commLeftRightPadding"
                            >
                              <ComboboxField
                                label="Truck Nmber"
                                placeholder=""
                                data={truckData}
                                id="loadingTruckNo"
                                iconClassName="dropdownIcon"
                                name="loadingTruckNo"
                                code="customerCode"
                                description="loadingTruckNoDesc"
                                setValue={formInputs?.loadingTruckNo || ""}
                                getvalue={setDropdownData}
                                required={true}
                                error={validation.loadingTruckNo}
                              />
                            </Col>
                            {formInputs?.loadingTruckNo === "000 - OTHERS" && (
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commLeftRightPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Truck Nmber"
                                  name="loadingOtherTruckNo"
                                  value={formInputs?.loadingOtherTruckNo || ""}
                                  onChange={onInputChange}
                                  error={validation.loadingOtherTruckNo}

                                  // disabled={true}
                                />
                              </Col>
                            )}
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commLeftRightPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Driver Name"
                                name="transporterDriverName"
                                value={formInputs?.transporterDriverName || ""}
                                onChange={onInputChange}
                                error={validation.transporterDriverName}
                                // disabled={true}
                              />
                            </Col>
                          </Row>
                          <p className="fs-5 mb-0">
                            {/* {invoiceData?.items
                                                ? invoiceData?.items[0]?.godownAddress
                                                : ""} */}
                          </p>
                        </Col>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>

            {/* table */}
            <div
              className="accordion sri-venkateshwara mb-4"
              id="accordionExample"
            >
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">CP</span>
                    </Col>
                    <Col xs={12} md={9} lg={9}>
                      <span className="headerTitle">Product Details</span>
                      <span className="subHeaderTitle">Product Details</span>
                    </Col>
                    <Col xs={12} md={2} lg={2} className="headerButtonAlign">
                      <button className="btnTable" onClick={addProductDetails}>
                        <i className="bi bi-plus-lg"></i> Add
                      </button>
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={getProductDetailsCol}
                          data={getProductDetailsData}
                          // progressPending={loading}
                          // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          // selectableRows
                          // onSelectedRowsChange={handleChange}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/*03 */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible3
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility3}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">ID</span>
                    </Col>

                    <Col xs={4} md={4} lg={4}>
                      <span className="headerTitle"> Invoice details</span>
                      <span className="subHeaderTitle">Invoice details</span>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible3 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <Row className="pt-2 pb-4">
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Total Bags"
                                name="sumOfOrderQuantityLoad"
                                id="sumOfOrderQuantityLoad"
                                value={totals?.totalBags}
                                onChange={onInputChange}
                                disabled={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Total Amount"
                                name="sumOfRate"
                                id="sumOfRate"
                                value={totals?.totalAmount}
                                onChange={onInputChange}
                                disabled={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Total CGST"
                                name="totalCgst"
                                id="totalCgst"
                                value={totals?.totalCgst}
                                onChange={onInputChange}
                                disabled={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Total SGST"
                                name="totalSgst"
                                id="totalSgst"
                                value={totals?.totalSgst}
                                onChange={onInputChange}
                                disabled={true}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Round Off"
                                name="difference"
                                id="difference"
                                value={difference}
                                onChange={onInputChange}
                                disabled={true}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Net Amount"
                                name="totalNetValue"
                                id="totalNetValue"
                                value={totals?.totalNetValue}
                                onChange={onInputChange}
                                disabled={true}
                              />
                            </Col>
                            <Row>
                              <Col
                                xs={12}
                                md={6}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Truck No"
                                  name="loadingTruckNo"
                                  id="loadingTruckNo"
                                  value={
                                    formInputs?.loadingTruckNo ===
                                    "000 - OTHERS"
                                      ? formInputs?.loadingOtherTruckNo
                                      : formInputs?.loadingTruckNoDesc
                                  }
                                  // onChange={onInputChange}
                                  disabled={true}
                                />
                              </Col>

                              <Col
                                xs={12}
                                md={6}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <ComboboxField
                                  label="e-Way Bill Number"
                                  extraLabel=""
                                  name="ewayBill"
                                  code="ewayBillCode"
                                  description="ewayBillDesc"
                                  data={ewayBillNumberData}
                                  id="ewayBill"
                                  iconClassName="dropdownIcon"
                                  setValue={invoiceData?.ewayBill}
                                  getvalue={setDropdownData}
                                  required={true}
                                  disabled={false}
                                  error={validation?.ewayBill}
                                />
                              </Col>
                              {/*  <Col
                                xs={12}
                                md={6}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Dispatch Document Number"
                                  name="dispatchDocumnetNr"
                                  id="dispatchDocumnetNr"
                                  value={invoiceData?.dispatchDocumnetNr}
                                  onChange={onInputChangeInvoice}
                                  disabled={false}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Bill of Lading / LR-RR No."
                                  name="billOfLading"
                                  id="billOfLading"
                                  value={invoiceData?.billOfLading}
                                  onChange={onInputChangeInvoice}
                                  disabled={false}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <ComboboxField
                                  label="Terms Of Payment"
                                  extraLabel=""
                                  name="termsOfPayment"
                                  code="termsOfPaymentCode"
                                  description="termsOfPaymentDesc"
                                  data={dropdownOption}
                                  id="termsOfPayment"
                                  iconClassName="dropdownIcon"
                                  setValue={invoiceData?.termsOfPayment}
                                  getvalue={setDropdownData}
                                  required={true}
                                  disabled={false}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                lg={6}
                                className="commTopButtonRightLeftPadding"
                              >
                                <TextAreaField
                                  className="inputBox"
                                  label="Terms of Delivery"
                                  type="text"
                                  name="termsOfDelivery"
                                  id="termsOfDelivery"
                                  value={invoiceData?.termsOfDelivery}
                                  onChange={onInputChangeInvoice}
                                  required={false}
                                />
                              </Col>
                              {invoiceData?.ewayBill === "Yes" && (
                                <Row>
                                  <Col
                                    xs={12}
                                    md={6}
                                    lg={3}
                                    className="commTopButtonRightLeftPadding"
                                  >
                                    <InputField
                                      className="inputBox"
                                      label="Generated Date"
                                      name="generatedDate"
                                      id="generatedDate"
                                      type="date"
                                      value={
                                        invoiceData?.generatedDate ||
                                        getTodaysData()
                                      }
                                      onChange={onInputChange}
                                      // disabled={!!diableEwaybill}
                                    />
                                  </Col>
                                  <Col
                                    xs={12}
                                    md={6}
                                    lg={3}
                                    className="commTopButtonRightLeftPadding"
                                  >
                                    <InputField
                                      className="inputBox"
                                      label="Distance"
                                      name="distance"
                                      id="distance"
                                      value={invoiceData?.distance}
                                      onChange={onInputChangeInvoice}
                                      // disabled={!!diableEwaybill}
                                    />
                                  </Col>
                                  <Col
                                    xs={12}
                                    md={6}
                                    lg={3}
                                    className="commTopButtonRightLeftPadding"
                                  >
                                    <InputField
                                      className="inputBox"
                                      label="Supply Type"
                                      name="supplyType"
                                      id="supplyType"
                                      value={invoiceData?.supplyType}
                                      onChange={onInputChangeInvoice}
                                      // disabled={!!diableEwaybill}
                                    />
                                  </Col>
                                  <Col
                                    xs={12}
                                    md={6}
                                    lg={3}
                                    className="commTopButtonRightLeftPadding"
                                  >
                                    <InputField
                                      className="inputBox"
                                      label="Transaction Type"
                                      name="transactionType"
                                      id="transactionType"
                                      value={invoiceData?.transactionType}
                                      onChange={onInputChangeInvoice}
                                      // disabled={!!diableEwaybill}
                                    />
                                  </Col>
                                  <Col
                                    xs={12}
                                    md={6}
                                    lg={3}
                                    className="commTopButtonRightLeftPadding"
                                  >
                                    <InputField
                                      className="inputBox"
                                      label="Mode"
                                      name="mode"
                                      id="mode"
                                      value={invoiceData?.mode}
                                      onChange={onInputChangeInvoice}
                                      // disabled={!!diableEwaybill}
                                    />
                                  </Col>
                                </Row>
                              )} */}
                            </Row>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
              <Row className="mt-4">
                <Col xs={12} md={2} lg={2} className="headerButtonAlign">
                  <button
                    className="btn btnInfo"
                    onClick={handleSave}
                    disabled={disable}
                  >
                    Generate Invoice
                  </button>
                </Col>
              </Row>
            </div>
          </div>
        </Col>
      </Row>
      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />
      <MaterialSelectionModal
        show={modalShow}
        onHide={() => hideModal()}
        onselectedcatdata={handleGetSelectedMaterial}
      />
    </main>
  );
};

export default ManualInvoiceCreate;
